import { css } from "styled-components";

export const sizes = {
  large: {
    min: 1100,
  },
  desktop: {
    min: 992,
  },
  tablet: {
    min: 768,
    max: 991,
  },
  tabletExt: {
    min: 901,
  },
  phone: {
    min: 0,
    max: 767,
  },
  phoneExt: {
    min: 0,
    max: 900,
  },
  default: {
    min: 768,
  },
};

const theme = {
  colors: {
    // Legacy colors
    yellow: "#F4B12E",
    lime: "#DCEBBD",
    // Marketing colors
    marketingBlue: "#75ccfc",
    // New colors
    gray25: "#f7f7f8",
    gray50: "#f2f2f3",
    gray100: "#e4e5e7",
    gray200: "#d5d6d8",
    gray300: "#bfc2c4",
    gray400: "#a0a3a7",
    gray500: "#808489",
    gray600: "#6c7075",
    gray700: "#53565a",
    gray800: "#3f4245",
    gray900: "#1d1f20",
    black: "#1d1f20",
    white: "#FFFFFF",
    green: "#087D4C",
    blue: "#0C60FF",
    red: "#D0201B",
    // Employer brand colors
    welchsPurple: "#652f8a",
  },
  spacing: {
    unit: 8,
  },
  media: {
    phone: (...args) => css`
      @media (min-width: 0px) and (max-width: 767px),
        (orientation: landscape) and (min-width: 0px) and (max-width: 914px) {
        ${css(...args)}
      }
    `,
    phoneQuery: window.matchMedia(
      "(min-width: 0px) and (max-width: 767px), (orientation: landscape) and (min-width: 0px) and (max-width: 914px)"
    ),
    large: (...args) => css`
      @media (min-width: 767px) and (max-width: 1100px),
        (orientation: landscape) and (min-width: 914px) and (max-width: 1100px) {
        ${css(...args)}
      }
    `,
    embedded: (...args) => css`
      @media (min-width: 0px) and (max-width: 400px),
        @media (min-height: 0px) and (max-height: 375px) {
        ${css(...args)}
      }
    `,
    hoverSupported: (...args) => css`
      @media (hover: hover) {
        ${css(...args)}
      }
    `,
    hoverSupportedDirect: (styles) => css`
      @media (hover: hover) {
        ${styles}
      }
    `,
    hoverSupportedQuery: window.matchMedia("(hover: hover)"),
    small: (...args) => css`
      @media (min-width: 0px) and (max-width: 1279px),
        (orientation: landscape) and (min-width: 0px) and (max-width: 1279px) {
        ${css(...args)}
      }
    `,
    smallQuery: window.matchMedia(
      "(min-width: 0px) and (max-width: 1279px), (orientation: landscape) and (min-width: 0px) and (max-width: 1279px)"
    ),
    mini: (...args) => css`
      @media (min-width: 0px) and (max-width: 743px) {
        ${css(...args)}
      }
    `,
    miniQuery: window.matchMedia("(min-width: 0px) and (max-width: 743px)"),
  },
  container: {
    medium: (...args) => css`
      @container (max-width: 504px) {
        ${css(...args)}
      }
    `,
    small: (...args) => css`
      @container (max-width: 320px) {
        ${css(...args)}
      }
    `,
    extraSmall: (...args) => css`
      @container (max-width: 256px) {
        ${css(...args)}
      }
    `,
  },
  // media: Object.keys(sizes).reduce((acc, label) => {
  //   acc[label] = (...args) => css`
  //     @media (min-width: ${sizes[label].min}px)
  //       ${sizes[label].max
  //         ? ` and (max-width: ${sizes[label].max}px)`
  //         : ""} {
  //       ${css(...args)}
  //     }
  //   `
  //   return acc
  // }, {}),
  // smallerSE: (...args) => css`
  //   @media (max-device-height: 567px) {
  //   ${css(...args)}
  //   }
  // `
};

export default theme;
